const formatKeys = {
    number: 'number',
    percent: 'percent',
    currency: 'currency',
    date: 'date',
    quarter: 'quarter',
    boolean: 'boolean',
    array: 'array',
    string: 'string',
    ids: 'ids'
};

const metrics = {
    GroupBy: {
        titleKey: 'day',
        isSortable: true,
        Day: {
            format: formatKeys.date,
            title: 'Day'
        },
        Offer: {
            format: formatKeys.ids,
            title: 'Offer'
        },
        UtmMedium: {
            format: formatKeys.ids,
            title: 'UtmMedium'
        },
        UtmSource: {
            format: formatKeys.ids,
            title: 'UtmSource'
        },
        UtmCampaign: {
            format: formatKeys.ids,
            title: 'UtmCampaign'
        },
        UtmTerm: {
            format: formatKeys.ids,
            title: 'UtmTerm'
        },
        UtmContent: {
            format: formatKeys.ids,
            title: 'UtmContent'
        }
    },
    Visits: {
        format: formatKeys.number,
        visible: true,
        isSortable: true
    },
    Visitors: {
        format: formatKeys.number,
        visible: true,
        isSortable: true
    },
    ActionTypeSaleCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'sales',
        visible: true,
        isSortable: true
    },
    ActionNameVerifiedCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'verified',
        visible: true,
        isSortable: true
    },
    ActionNameRegCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'regs',
        visible: true,
        isSortable: true
    },
    ConversionRatioToRegConfirmed: {
        format: formatKeys.percent,
        titleKey: 'reg',
        visible: true,
        isSortable: true
    },
    PublisherEarnPerClickAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'epc',
        visible: true,
        isSortable: true
    },
    FirstPaymentCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'FTDsCount',
        visible: true,
        isSortable: true
    },
    TotalPaymentCountConfirmed: {
        format: formatKeys.number,
        titleKey: 'totalCount',
        visible: true,
        isSortable: true
    },
    FirstPaymentSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'FTDsSum',
        visible: true,
        isSortable: true
    },
    TotalPaymentSumConfirmed: {
        format: formatKeys.currency,
        titleKey: 'totalSum',
        visible: true,
        isSortable: true
    },
    PublisherAnnouncedTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'announcedCommission',
        visible: true
    },
    PublisherCreditTotalAmountConfirmed: {
        format: formatKeys.currency,
        titleKey: 'total',
        visible: true,
        isSortable: true
    }
};

const treeMetric = [
    [
        {
            config: {
                key: 'groups',
                metrics: ['GroupBy']
            }
        },
        {
            config: {
                key: 'traffic',
                metrics: ['Visits', 'Visitors']
            }
        },
        {
            config: {
                key: 'actions',
                metrics: ['ActionTypeSaleCountConfirmed', 'ActionNameVerifiedCountConfirmed', 'ActionNameRegCountConfirmed']
            }
        },
        {
            config: {
                key: 'conversion',
                titleTemplate: '{{ title }} (CR)',
                metrics: ['ConversionRatioToRegConfirmed']
            }
        },
        {
            config: {
                key: 'regs',
                metrics: ['PublisherEarnPerClickAmountConfirmed']
            }
        },
        {
            config: {
                key: 'deposit',
                metrics: ['FirstPaymentCountConfirmed', 'TotalPaymentCountConfirmed', 'FirstPaymentSumConfirmed', 'TotalPaymentSumConfirmed']
            }
        },
        {
            config: {
                key: 'commission',
                metrics: ['PublisherAnnouncedTotalAmountConfirmed', 'PublisherCreditTotalAmountConfirmed']
            }
        }
    ]
];

export {
    formatKeys,
    metrics,
    treeMetric
};
